import styled from "@emotion/styled";
import React from "react";

import type { ButtonModifiers } from "@brexhq/next/src/components/shared/Button/types";
import { CoreLink } from "@brexhq/next/src/components/shared/Link/CoreLink";
import type {
  ButtonLinkProps,
  ButtonMargins,
  ResponsiveButtonSizes,
} from "@brexhq/next/src/components/shared/Link/types";
import { createButtonStyles } from "@brexhq/next/src/components/shared/styles/Button.elements";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";

import { IconPicker } from "../../building-blocks/IconPicker/IconPicker";

// TODO Nav Link, Footer Link, Legal Link

const StyledButtonLink = styled(CoreLink, {
  shouldForwardProp: (prop) =>
    ![
      "margin",
      "modifier",
      "size",
      "isFullWidth",
      "moduleTheme",
      "withIcon",
    ].includes(prop),
})<{
  margin?: ButtonMargins;
  modifier?: ButtonModifiers;
  size?: ResponsiveButtonSizes;
  isFullWidth?: boolean;
  moduleTheme: ModuleThemeType;
  withIcon?: boolean;
}>(
  ({
    margin,
    modifier = "primary",
    size,
    isFullWidth,
    moduleTheme,
    withIcon,
  }) =>
    createButtonStyles({
      modifier,
      margin,
      size,
      isFullWidth,
      theme: moduleTheme,
      withIcon,
    }),
);

export const PrimaryButtonLink = React.forwardRef<
  HTMLAnchorElement,
  ButtonLinkProps
>(function PrimaryButtonLinkComponent(
  // Ignoring this because we want to extract the theme prop from defaultProps
  // eslint-disable-next-line
  {
    to,
    label,
    margin,
    theme = "PrimaryWhite",
    modifier,
    size,
    target,
    rel,
    prefetch,
    isFullWidth,
    icon,
    withIcon,
    iconColor,
    ...defaultProps
  },
  ref,
) {
  return (
    <StyledButtonLink
      ref={ref}
      margin={margin}
      to={to}
      size={size}
      target={target}
      rel={rel}
      modifier={modifier}
      moduleTheme={theme}
      prefetch={prefetch}
      isFullWidth={isFullWidth}
      withIcon={withIcon}
      {...defaultProps}
    >
      {icon && withIcon && (
        <IconPicker
          theme={theme}
          marginTop="none"
          size={{ LRG: "med", MED: "med", SML: "sml" }}
          icon={icon}
          color={iconColor ?? "single"}
        />
      )}
      {label}
    </StyledButtonLink>
  );
});
